import { IOrderBasisAdjustment } from '@/coreDomainsModule/entities/orderBasis';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { UpsertAndSingleSimulationOrderRequestInfo, UpsertOrderInfo } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { OrderBasisUserAdjustedAdapter } from '@/coreUseCasesModule/orderBasis/adapters/OrderBasisUserAdjustedAdapter';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class upsertAndSingleSimulationOrderAdapter {
  /**
   * フロント側の発注情報の型、IAnnounceからBulkPostOrderResponseInfoに変換を行う
   * @param registerOrderInfo - 登録を行う発注情報
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisAdjustmentInfo - 発注根拠情報
   */
  public static requestAdapter = (
    registerOrderInfo: DisplayIArrival,
    aggregateBusinessId: string,
    orderBasisAdjustmentInfo: IOrderBasisAdjustment
  ): UpsertAndSingleSimulationOrderRequestInfo => {
    const crossDate = registerOrderInfo.crossDate ? DateService.convertIDateToDate(registerOrderInfo.crossDate) : new Date();
    const adaptedOrderInfo: UpsertOrderInfo = {
      orderId: registerOrderInfo.arrivalId,
      desiredDeliveryDate: DateService.formatDateToISOString(crossDate), // 希望納期
      estimatedTimeOfArrival: DateService.formatDateToISOString(crossDate), // 納期
      orderAmount: registerOrderInfo.amount,
      orderStatus: registerOrderInfo.status ? registerOrderInfo.status : 'Recommended',
      orderNote: registerOrderInfo.memoText,
    };
    return {
      upsertOrderInfo: adaptedOrderInfo,
      aggregateBusinessId: aggregateBusinessId,
      displayId: registerOrderInfo.displayId,
      orderBasisAdjustment: OrderBasisUserAdjustedAdapter.adapt(orderBasisAdjustmentInfo),
    };
  };
}
